<template>
    <div class="content-wrapper primary-table career-table">
        <div class="row">
            <div class="col-sm-12 d-md-none">
                <app-breadcrumb :page-title="$t('career')" :directory="$t('datatables')" :icon="'grid'"/>
            </div>

            <div class="col-sm-12 col-md-12 breadcrumb-side-button-add">
                <div class="float-md-right mt-1 mb-sm-3 mb-md-0 text-right">
                    <button type="button"
                            class="btn btn-primary btn-with-shadow"
                            data-toggle="modal"
                            @click="openAddEditModal">
                        <i class="custom-icon custom-icon-button-inline custom-icon-plus"></i>
                        {{ $t('add') }}<span class="d-none d-md-inline"> {{ $t('advert_template_job_title') }}</span>

                    </button>
                </div>
            </div>


        </div>

        <app-table
            :id="tableId"
            :options="options"
            :filtered-data="filteredData"
            @getRows="getSelectedRows"
            @getRowsAction="getSelectedRowsAction"
            @getAddButtonAction="openAddEditModal"
            @action="getListAction"
        />




        <app-career-add-modal
            v-if="isAddEditModalActive"
            :table-id="tableId"
            :selected-url="selectedUrl"
            :modal-type="modalType"
            @close-modal="closeAddEditModal"
            @close-and-open-modal="closeAddEditModalAndOpen"
        />

        <app-rejection-modal
            v-if="rejectionModalActive"
            :table-id="tableId"
            :selected-rows="this.selectedRows"
            modal-id="rejection-modal"
            modal-size="large"
            modal-alignment="top"
            @close-modal="closeRejectionModal"
        />

        <app-share-modal
            v-if="shareModalActive"
            :table-id="tableId"
            :selected-rows="this.selectedRows"
            modal-id="notification-modal"
            modal-size="large"
            modal-alignment="top"
            @close-modal="closeShareModal"
        />

        <app-delete-modal
            v-if="deleteConfirmationModalActive"
            :preloader="deleteLoader"
            modal-id="demo-delete"
            @confirmed="confirmed"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import {TableHelpers} from './mixins/TableTemplateHelpers';

export default {
    extends: CoreLibrary,
    name: "DatatableWithFilter",
    mixins: [TableHelpers],
    data() {
        return {
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            shareModalActive: false,
            rejectionModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            selectedCandidates: '',
            modalType: 'add-edit-modal',
            tableId: 'careerTemplates',
            filteredData: {
                name: '',
            },
            rowData: {},
            options: {
                name: 'CareerTable',
                url: actions.DATATABLE_CAREERS_DATA,
                showHeader: true,
                columns: [],
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit-3',
                        type: 'none',
                        className: 'edit ml-4',
                        component: 'app-career-add-modal',
                        modalId: 'add-edit-Modal',
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'none',
                    }
                ],

                filters: [

                    {
                        "title": "Status",
                        "type": "hidden",
                        "key": "filter-with-status-id",
                        "initValue": 4, // 4=template , 2=career archive, 1=career
                        "option": [],
                    },

                    {
                        "title": this.$t('date_created_filter'),
                        "type": "range-picker",
                        "key": "date",
                        "option": [
                            "today", "thisMonth", "last7Days"
                        ]
                    },
                ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 5,
                showAction: true,
                actionSelectOptions: [
                    {id: '1', value: this.$t('reject_candidate')},
                    {id: '2', value: this.$t('share_with_manager')},
                    {id: '3', value: this.$t('change_state...')},
                    // {id: '4', value: this.$t('start_hiring')},
                    {id: '5', value: this.$t('start_onboarding')},
                ],
                actionSelectedOption: 1,
                timelineState: [
                    {id: '0', value: 'Vyberte'},
                    {id: '1', value: 'Uchazeči'},
                    {id: '2', value: 'Předvýběr'},
                    {id: '3', value: '1. kolo'},
                    {id: '4', value: '2. kolo'},
                    {id: '5', value: '3. kolo'},
                    {id: '6', value: 'K přijetí'},
                    // @todo: axios GET FROM timeline WHERE job = x
                ],
                timelineSelectedState: 0,
                orderBy: 'desc',
                actionType: "default",
                tableShadow: false,
                emptyText: this.$t('nothing_to_show_here_hiring'),
                showEmptyAnimation: true,
                showComments: false,
                showTopBar: false,
                showTimeline: false,
                showAddButton: false,
                datatableParentId: 0, // 3=onboarding, 2=hiring, 1=talentpool, 0=careers
                // actionType: "dropdown",
                enableRowSelect: false,
                // tablePaddingClass: 'p-primary'
                tableClass: 'primary-table',

                currentMainTab: 0,
                mainTabs: [
                    {page: actions.DATATABLE_CAREERS_TEMPLATE_URL, pageName: this.$t('advert_templates')},
                    {page: actions.DATATABLE_MAIL_TEMPLATES_URL, pageName: this.$t('email_templates')},

                ],


            },

        }
    },
    created() {
        this.options.columns = [...this.tableColumns, this.actionObj];
        this.searchAndSelectFilterOptions();

        /**
         * for open modal after clicking on notification and etc.
         */
        if(this.getDefaultCandidate()){
            if(this.getDefaultCandidate() == 'new'){
                this.selectedUrl = ``;
            } else {
                this.selectedUrl = `${actions.DATATABLE_CAREERS_DATA}/${this.getDefaultCandidate()}`;
            }

            this.openAddEditModal();
        }

    },
    methods: {
        /**
         * for open modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },
        openRejectionModal() {
            this.rejectionModalActive = true;
        },
        openShareModal() {
            this.shareModalActive = true;
        },
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        /**
         * for close modal
         */
        closeAddEditModal() {
            $("#add-edit-Modal").modal('hide');
            this.isAddEditModalActive = false;
            this.searchAndSelectFilterOptions();
            this.reSetData();

            // Add page after visited candidate to history
            if (history.replaceState) {
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                window.history.replaceState({path:newurl},'',newurl);
            }
        },
        closeRejectionModal() {
            this.rejectionModalActive = false;
            this.reSetData();
            console.log('close modal');
        },
        closeShareModal() {
            this.shareModalActive = false;
            this.reSetData();
            console.log('close modal');
        },
        closeAddEditModalAndOpen(modal, candidate) {
            this.closeAddEditModal();

            if(modal == 'notification'){
                this.selectedRows = candidate;
                this.openShareModal();
            } else if (modal == 'rejection'){
                this.selectedRows = candidate;
                this.openRejectionModal();
            }

        },


        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;

            if (actionObj.title == this.$t('delete')) {
                this.moveCareerTo(rowData.id, 3);
            } else if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${actions.DATATABLE_CAREERS_DATA}/${rowData.id}`;
                this.openAddEditModal();
            } else if (actionObj.title == this.$t('share_on_linkedin')) {
                this.linkedInShare(rowData.url, rowData.job, rowData.advert);
            } else if (actionObj.title == this.$t('share_on_facebook')) {
                this.fbShare(rowData.url, rowData.job, rowData.advert);
            }else if (actionObj.title == this.$t('share_on_twitter')) {
                this.twitterShare(rowData.url, rowData.job, rowData.job);
            } else if (actionObj.title == this.$t('get_recommandation')) {

                let advertText = rowData.advert.replace(/<br>/g, "%0D%0A%0D%0A").replace(/<li>/g, "%0D%0A– ").replace(/<ul>/g, "%0D%0A");

                this.mailShare(rowData.url, rowData.job, $(advertText).text());
            }
        },


        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.DATATABLE_CAREERS_DATA}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#demo-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                    this.searchAndSelectFilterOptions();
                }).catch(({error}) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
        searchAndSelectFilterOptions() {



        },


        /**
        * sharing action
        */
            fbShare(url, title, descr) {
                let winWidth = 350;
                let winHeight = 520;
                let winTop = (screen.height / 2) - (winHeight / 2);
                let winLeft = (screen.width / 2) - (winWidth / 2);
                window.open('http://www.facebook.com/sharer.php?s=100&p[title]=' + title + '&p[url]=' + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
            },

            linkedInShare(url, title, descr) {
                let winWidth = 350;
                let winHeight = 520;
                let winTop = (screen.height / 2) - (winHeight / 2);
                let winLeft = (screen.width / 2) - (winWidth / 2);
                let shareUrl = 'https://kariera.ebrana.cz/obchodnik-v-oboru-online-marketingu';
                window.open('https://www.linkedin.com/sharing/share-offsite/?url='+escape(shareUrl) + '&title=' + document.title + '', '_blank', 'width=350,height=520')
            },

            twitterShare(url, title, descr) {
                let winWidth = 350;
                let winHeight = 520;
                let winTop = (screen.height / 2) - (winHeight / 2);
                let winLeft = (screen.width / 2) - (winWidth / 2);
                window.open('https://twitter.com/intent/tweet?text=' + this.$t("twitter_share_text") + descr + ' %0A' + url, 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
            },

            mailShare(url, title, descr) {
                let winWidth = 350;
                let winHeight = 520;
                let winTop = (screen.height / 2) - (winHeight / 2);
                let winLeft = (screen.width / 2) - (winWidth / 2);
                let emailTo = '';
                let emailBCC = '';
                window.open('mailto:'+emailTo+'?bcc='+emailBCC+'&subject=' + this.$t("twitter_share_text") + title + '&body='+descr, '_self');
            },


        /**
         * Show Datatable Filter by last job I have visited / by parameters in URL
         */
        getUrlParameter(name, url) {
            if (!url) url = location.href;
            name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
            var regexS = "[\\?&]"+name+"=([^&#]*)";
            var regex = new RegExp( regexS );
            var results = regex.exec( url );
            return results == null ? null : results[1];
        },
        getCookie(name) {
            var match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
            return match ? match[1] : null;
        },
        getDefaultCandidate(){
            if(location.href.indexOf("?job") >= 0){
                return parseInt(this.getUrlParameter('job', location.href));
            } else if (location.href.indexOf("?new") >= 0){
                return 'new';
            }
        },

        /**
         * get Selected Rows
         */
        getSelectedRows(value) {
            this.selectedRows = value;
        },


        /**
         * do Selected Action with Selected Rows
         */
        getSelectedRowsAction() {

        },

        /**
         * move To Archive / disable advert
         */
        moveCareerTo(id, status) {

            let selectedBulkEditData = {
                career_id: id,
                status: status
            };

            this.axiosPatch({
                    url: 'bulk-edit/careers',
                    data: selectedBulkEditData
                }).then(response => {

                    if (response.data) {
                        this.afterSuccess(response);
                    } else {
                        this.afterError(response);
                    }

                }).finally(() => {
                    this.tagPreloader = false;
                });

        },

        afterSuccess(response) {
            $(".floating-bar-fixed-bottom").addClass("animate__fadeOut").delay(500).fadeOut();
            this.$hub.$emit('reload-' + this.tableId);
            this.$toastr.s(this.$t(response.data));

        },
        afterError(response) {
            $(".floating-bar-fixed-bottom").addClass("animate__fadeOut").delay(500).fadeOut();
            this.$hub.$emit('reload-' + this.tableId);
            this.$toastr.s(this.$t(response.data));

        },



        /**
         * get Status Filter
         */
        getSearchValue(value) {
                let instance = this;
                this.search = value;
                setTimeout(function () {
                    instance.$hub.$emit('reload-' + instance.tableId);
                });
            },
            getFilterValue(item) {
                this.filteredData.status = item;
                console.log('test '+item);
                this.$hub.$emit('reload-'+this.tableId);
            }

    },
}
</script>
